import { useDiffitUserContext } from '../contexts/DiffitUserContext';
import { getTrialCountdownParts } from '../utils/exportTrialState';

// Renders the export trial countdown, emphasizing the time-remaining clause.
// Copy lives in getTrialCountdownParts (ANCHOR: export-trial-copy).
const TrialCountdownText = () => {
  const { daysLeftInTrial, diffitUser } = useDiffitUserContext();
  const { lead, emphasis } = getTrialCountdownParts(daysLeftInTrial, diffitUser);
  return (
    <span>
      {lead}
      {emphasis && <span className='font-semibold whitespace-nowrap'>{emphasis}</span>}.
    </span>
  );
};

export default TrialCountdownText;
